import { Vue, router, store } from "@/main";
import { TRANSFORM_ACCOUNT } from "@/store/constants/index_types";
import {
  GETTER_INS_USER_INFO_BY_ID,
  GETTER_CURRENT_INS_USER_INFO
} from "@/store/constants/ins_user_info_types";
import { findRouteIndex } from "@/plugins/navigation/routes";
import { goToLogin } from "@/utils/router_helper";
import VipRetain from "@/components/DlalogTsx/BindVip/VipRetain";
import generator from "@/services/open_pop_up/open_generator";
import { download_redirect_app } from "@/utils/app_download";
import HeadersCommon from "@/components/DlalogTsx/EarnCoins/HeadersCommon";
import { getCurrentRoute } from "@/plugins/navigation/routes";
import FollowDifferenceContent from "@/components/DlalogTsx/FollowDifference/FollowDifferenceContent";
import FollowDifferenceBtn from "@/components/DlalogTsx/FollowDifference/FollowDifferenceBtn";
import SwitchBackgroundPosition, {
  SwitchPositionTypes
} from "@/utils/switch_background/switch_background_position";
import RecommendAppHeader from "@/components/DlalogTsx/SuperPay/RecommendAppHeader";
import SuperPayButton from "@/components/DlalogTsx/SuperPay/SuperPayButton";
import SuperPayContent from "@/components/DlalogTsx/SuperPay/SuperPayContent";
import { RedirectApp } from "@/services/open_pop_up/types";
import BindVipConfirmHeader from "@/components/DlalogTsx/BindVip/BindVipConfirm";
import BindVipConfirmContent from "@/components/DlalogTsx/BindVip/BindVipConfirmContent";
import { sendEvent } from "@/utils/log_event";
import { UIA_SP_SHOW, UIA_SP_CLICK } from "@/utils/log_event/event_const";
import AutoPaymentCache from "@/services/super_pay/auto_payment_cache";
import { downloadApps } from "@/utils/app_download";
import { back_up_show_rewards } from "@/services/super_pay/super_pay_helper";
import { bindUserToVip } from "@/services/vip/vip_bind";
import { getDeviceInfo, getDisplayName } from "@/utils/js_bridge_info";
import PermissionContent from "@/components/DlalogTsx/Permission/PermissionContent";
import Jsbridge from "@/jsbridge";

export const showClaimVipRetain = () => {
  try {
    Vue.prototype.$_Dialog.show({
      title: "Claim VIP Benefits",
      content: {
        text: `Don’t forget to add an Instagram account to get 10 bonus followers every day.`
      },
      closable: false,
      headerCustom(ctx: any, r: any) {
        return r(VipRetain, { props: { ctx } });
      },
      cancelBtn: {
        text: "Not Now"
      },
      confirmBtn: {
        text: "ADD ACCOUNT"
      },
      onConfirm(done: any) {
        goToLogin();
        done();
      },
      onCancel(done: any) {
        done();
        // 退出 支付落地页
        let routeBack = 1;
        if (findRouteIndex("VipPage") > -1 || findRouteIndex("VipToast") > -1) {
          ++routeBack;
        }
        router.go(-routeBack);
      }
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const showUpgradeApp = async (payload: RedirectApp) => {
  try {
    const { is_force_redirect, title, desc } = payload;
    await Vue.prototype.$_Dialog.show({
      avatar: require("@/assets/icons-file/dialog/picNewversionPopup@2x.png"),
      title,
      content: {
        text: desc
      },
      closeFun: true,
      closable: !is_force_redirect,
      cancelBtn: !is_force_redirect
        ? {
            text: "Not Now"
          }
        : {},
      confirmBtn: {
        text: "UPGRADE NOW"
      },
      onConfirm(done: any) {
        try {
          store.dispatch(TRANSFORM_ACCOUNT);
          download_redirect_app(payload);
          SwitchBackgroundPosition.setPosition(
            SwitchPositionTypes.NOT_REQUIRE_REFRESH
          );
        } catch (error) {
          console.log("download_back_up", error);
        }
      },
      onModalCloseWithIcon(done: any) {
        done();
        generator.next();
      },
      onCancel(done: any) {
        done();
        generator.next();
      }
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const showLoginRequired = (payload: string) => {
  try {
    // 弹窗之前必须先判断当前是否在被调的页面backup:
    if (getCurrentRoute() && !getCurrentRoute().path.includes("Home")) {
      return;
    }
    const insUserInfo = store.getters[GETTER_INS_USER_INFO_BY_ID](payload);

    if (insUserInfo) {
      const { ins_user_info } = insUserInfo;
      const { profile_pic_url, user_name } = ins_user_info;
      const icon = require("@/assets/icons-file/dialog/pic_popup_loginrequired.png");
      Vue.prototype.$_Dialog.show({
        title: "Login Required",
        content: {
          text: `Dear @${user_name}, your account has expired, please login again.`
        },
        headerCustom(ctx: any, r: any) {
          return r(HeadersCommon, {
            props: {
              ctx,
              icon,
              picUrl: profile_pic_url
            }
          });
        },
        closable: true,
        confirmBtn: {
          text: "LOGIN NOW"
        },
        onConfirm(done: any) {
          goToLogin();
          done();
        }
      });
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const showCompleteProfile = (payload: string) => {
  try {
    const insUserInfo = store.getters[GETTER_INS_USER_INFO_BY_ID](payload);
    if (insUserInfo) {
      const { ins_user_info } = insUserInfo;
      const { profile_pic_url, user_name } = ins_user_info;
      const icon = require("@/assets/icons-file/dialog/pic_popup_profileinfoincomplete.png");
      Vue.prototype.$_Dialog.show({
        title: "Profile Info Incomplete",
        content: {
          text: `Dear @${user_name}, please set your profile photo and post your first photo before you could earn more coins!`
        },
        headerCustom(ctx: any, r: any) {
          return r(HeadersCommon, {
            props: {
              ctx,
              icon,
              picUrl: profile_pic_url
            }
          });
        },
        closable: true,
        confirmBtn: {
          text: "OK"
        },
        onConfirm(done: any) {
          done();
          router.push({
            name: "CompleteProfile",
            query: {
              routerTransition: "forward",
              userInfo: JSON.stringify(insUserInfo)
            }
          });
        }
      });
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const showFollowDifference = () => {
  try {
    Vue.prototype.$_Dialog.show({
      title: "Followers Differences",
      closeOnClickModal: true,
      closable: true,
      style: { padding: "0 17px 28px" },
      contentCustom(ctx: any, r: any) {
        return r(FollowDifferenceContent, { props: { ctx } });
      },
      confirmBtnCustom: (ctx: any, r: any) => {
        return r(FollowDifferenceBtn, { props: { ctx } });
      },
      onConfirm(done: any) {
        done();
      }
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const showRecommendDialog = async (payload: any) => {
  const { super_pay, back_up, feature_apps, place, offer } = payload;
  let pic_placeholder: any;
  let content: any;
  let click_point_key = "";
  let dialog_class = "";
  let rewards: number = 0;
  if (super_pay) {
    pic_placeholder = require("@/assets/icons-file/super_pay/super_pay_placeholder/sp_place_n@3x.png");
    content = super_pay;
    dialog_class = "super_pay";
    click_point_key = "uia_superpay_app_click";
    const videoUrl = super_pay.video_url || super_pay.videoUrl;
    const videoPathList = videoUrl.split("/");
    const promo_video = videoPathList[videoPathList.length - 1];
    sendEvent(UIA_SP_SHOW, {
      situation: "payment_choice",
      style: "alert",
      promo_video
    });
    setTimeout(() => {
      AutoPaymentCache.set({ offer, pay_way: "back_up" });
      downloadApps(content);
      sendEvent(UIA_SP_CLICK, {
        promo_video,
        situation: "payment_choice",
        style: "alert",
        action: "auto_get"
      });
    }, 1000);
  } else if (back_up) {
    pic_placeholder = require("@/assets/icons-file/super_pay/super_pay_placeholder/ba_place_n@3x.png");
    content = back_up;
    click_point_key = "uia_backup_app_click";
    rewards = await back_up_show_rewards();
  } else if (feature_apps) {
    pic_placeholder = require("@/assets/icons-file/super_pay/super_pay_placeholder/fa_place_n@3x.png");
    content = feature_apps;
    click_point_key = "uia_featured_app_click";
  }
  Vue.prototype.$_Dialog.show({
    style: { padding: "0 0 28px" },
    closable: false,
    closeOnClickModal: true,
    headerCustom(ctx: any, r: any) {
      return r(RecommendAppHeader, {
        props: { ctx, content, dialog_class, pic_placeholder, offer }
      });
    },
    contentCustom(ctx: any, r: any) {
      return r(SuperPayContent, { props: { ctx, content } });
    },
    confirmBtnCustom(ctx: any, r: any) {
      return r(SuperPayButton, {
        props: {
          ctx,
          padding: true,
          item: content,
          dialog_class,
          place,
          click_point_key,
          offer,
          rewards
        }
      });
    }
  });
};

export const bindVipDialog = () => {
  try {
    const currentUserInfo = store.getters[GETTER_CURRENT_INS_USER_INFO];
    Vue.prototype.$_Dialog.show({
      title: "Confirm Account",
      closable: false,
      headerCustom(ctx: any, r: any) {
        return r(BindVipConfirmHeader, { props: { ctx } });
      },
      contentCustom(ctx: any, r: any) {
        return r(BindVipConfirmContent, { props: { ctx } });
      },
      cancelBtn: {
        text: "NOT THIS ACCOUNT"
      },
      onConfirm: async (done: any) => {
        try {
          done();
          const bindVipResult = await bindUserToVip();
          console.log("bindVipResult", bindVipResult);
        } catch (error) {
          console.log("bind error", error);
        }
      },
      onCancel(done: any) {
        done();
        //  点击取消 显示search 框
        // Event_bus.$emit("show-lit-search", true);
        goToLogin();
      }
    });
  } catch (error) {
    return error;
  }
};

export const showAllowPermissionDialog = (val: string) => {
  try {
    Vue.prototype.$_Dialog.show({
      title: "Allow Permission",
      contentCustom(ctx: any, r: any) {
        return r(PermissionContent, {
          props: { appName: getDisplayName(), val }
        });
      },
      closable: true,
      closeOnClickModal: true,
      onConfirm(done: any) {
        done();
        const DeviceInfotest = getDeviceInfo();
        const { app_setting_url } = DeviceInfotest;
        Jsbridge.openBrowser(app_setting_url);
      },
      confirmBtn: {
        text: val === "photo" ? "Enable Photos Access" : "Enable Camera Access"
      },
      cancelBtn: {
        text: "Cancel"
      }
    });
  } catch (e) {
    return e;
  }
};
